import { render } from "./ItemLichSu.vue?vue&type=template&id=38f77515"
import script from "./ItemLichSu.vue?vue&type=script&lang=js"
export * from "./ItemLichSu.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__